import { FC, useCallback } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { useNavigate } from 'react-router';
import * as routes from 'router/Routes';
import { SortOrder } from 'utils/array';
import SortableTable, { HeaderCell } from 'components/UI/Table/SortableTable';
import { Registration } from 'models/lwm2m';
import { fetchRegistrationList } from 'store/lwm2mState/lwm2mState';
import { timeToParts } from 'utils/lwm2m';

const headerCells: HeaderCell[] = [
  {
    title: 'lwm2m.timestamp',
    sortable: true,
  },
  {
    title: 'lwm2m.iprId',
    sortable: true,
  },
  {
    title: 'lwm2m.duration',
    sortable: true,
  },
];

type Props = {
  registrations: Registration[];
};

const RegistrationTable: FC<Props> = ({ registrations }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Fetch devices and navigate
  const onClick = useCallback(
    (iprId: string) => {
      if (iprId) {
        dispatch(fetchRegistrationList([], 0));
      }
      navigate(`${routes.LWM2M}/${iprId}`);
    },
    [dispatch, navigate]
  );

  // Table rows
  const bodyRows = registrations.map(({ attributes }) => {
    const { timestamp, iprId, duration } = attributes;
    return {
      timestamp,
      iprId,
      duration: timeToParts(duration, 2) || '–',
      link: iprId,
    };
  });

  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={bodyRows}
      onClick={onClick}
      sortOrder={SortOrder.Asc}
      sortIndex={2}
    />
  );
};

export default RegistrationTable;
